import fetch from '@/service/fetch';

export function getData() {
  return fetch('/api/portal/act/activity-index');
}

export function getActivityList(params) {
	return fetch('/api/portal/act/activity/page', {
		data: params
	})
}

export function getMeetingList(params) {
	return fetch('/api/portal/act/meeting/page', {
		data: params
	})
}

export function getSalonList(params) {
	return fetch('/api/portal/act/salon/page', {
		data: params
	})
}

export function getActivityDetail(id) {
  return fetch(`/api/portal/act/activity/find/${id}`);
}

export function getSalonDetail(id) {
  return fetch(`/api/portal/act/salon/find/${id}`);
}

export function getMeetingDetail(id) {
  return fetch(`/api/portal/act/meeting/find/${id}`);
}

export function getAwardDetail(id) {
  return fetch(`/api/portal/act/award/find/${id}`);
}

export function actSignUp(params) {
	return fetch('/api/u-portal/act/sign-up', {
		data: params,
		method: 'POST'
	})
}

export function awardSignUp(params) {
	return fetch('/api/u-portal/act/sign-up-award', {
		data: params,
		method: 'POST'
	})
}

export function submitScanningCopy(params) {
	return fetch('/api/u-portal/act/scanning-copy', {
		data: params,
		method: 'POST'
	})
}


export function getAwardSignInfo(id) {
  return fetch(`/api/u-portal/act/sign-up-award/find/by-act/${id}`);
}

export function getSignConfig(params) {
	return fetch('/api/portal/act/form-config', {
		data: params
	});
}